/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { ADPComponentsModule } from 'digital-core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-chat-hours-modal-window',
    templateUrl: './chat-hours-modal-window.component.html',
    imports: [ModalWindowComponent, ADPComponentsModule, MatButton]
})
export class ChatHoursModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<ChatHoursModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  closeModal() {
    this.dialogRef.close();
  }
}
